var _g, _mask, _path, _path2, _path3, _path4, _mask2, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 214,
    viewBox: "0 0 285 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_331_164)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 0.000732422,
    width: 277,
    height: 44,
    rx: 10,
    fill: "#E28413"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 1.50073,
    width: 274,
    height: 41,
    rx: 8.5,
    stroke: "black",
    strokeWidth: 3
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_331_164",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 10.0007C4 4.47789 8.47715 0.000732422 14 0.000732422H19V44.0007H14C8.47715 44.0007 4 39.5236 4 34.0007V10.0007Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 10.0007C4 4.47789 8.47715 0.000732422 14 0.000732422H19V44.0007H14C8.47715 44.0007 4 39.5236 4 34.0007V10.0007Z",
    fill: "#E28413"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 10.0007C4 4.47789 8.47715 0.000732422 14 0.000732422H19V44.0007H14C8.47715 44.0007 4 39.5236 4 34.0007V10.0007Z",
    fill: "black",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.0007C1 2.82103 6.8203 -2.99927 14 -2.99927H19V3.00073H14C10.134 3.00073 7 6.13474 7 10.0007H1ZM19 47.0007H14C6.8203 47.0007 1 41.1804 1 34.0007H7C7 37.8667 10.134 41.0007 14 41.0007H19V47.0007ZM14 47.0007C6.8203 47.0007 1 41.1804 1 34.0007V10.0007C1 2.82103 6.8203 -2.99927 14 -2.99927V3.00073C10.134 3.00073 7 6.13474 7 10.0007V34.0007C7 37.8667 10.134 41.0007 14 41.0007V47.0007ZM19 0.000732422V44.0007V0.000732422Z",
    fill: "black",
    mask: "url(#path-3-inside-1_331_164)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5 42.5007H231.5V204.001C231.5 208.695 227.694 212.501 223 212.501H62C57.3056 212.501 53.5 208.695 53.5 204.001V42.5007Z",
    fill: "#E28413",
    stroke: "black",
    strokeWidth: 3
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-2_331_164",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52 41.0007H67V214.001H62C56.4772 214.001 52 209.524 52 204.001V41.0007Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41.0007H67V214.001H62C56.4772 214.001 52 209.524 52 204.001V41.0007Z",
    fill: "#E28413"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41.0007H67V214.001H62C56.4772 214.001 52 209.524 52 204.001V41.0007Z",
    fill: "black",
    fillOpacity: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49 38.0007H67V44.0007H55L49 38.0007ZM67 217.001H62C54.8203 217.001 49 211.18 49 204.001H55C55 207.867 58.134 211.001 62 211.001H67V217.001ZM62 217.001C54.8203 217.001 49 211.18 49 204.001V38.0007L55 44.0007V204.001C55 207.867 58.134 211.001 62 211.001V217.001ZM67 41.0007V214.001V41.0007Z",
    fill: "black",
    mask: "url(#path-6-inside-2_331_164)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_331_164",
    x: 0,
    y: 0.000732422,
    width: 285,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_331_164"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_331_164",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPot);
export default __webpack_public_path__ + "static/media/pot.817379c24340a579e7f4090eca9e866a.svg";
export { ForwardRef as ReactComponent };